// apps/account-portal/src/components/PageFooter.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * 公開頁頁尾：服務條款、隱私權、退款政策、聯絡我們（綠界審核要求網站公開這些資訊）
 * 聯絡我們連到聯絡頁，不直接用 mailto：沒設定預設郵件程式的電腦點了會沒反應
 * 營運者是個人、尚未設立公司，名稱只寫「RedPanda Tech」，不加 Co., Ltd.／有限公司
 */
const PageFooter: React.FC = () => {
  const { t } = useTranslation();
  const link = 'hover:text-[var(--text-primary)] hover:underline';
  return (
    <footer className="mt-12 pt-6 border-t border-[var(--border-c)] text-center text-[13px] text-[var(--text-muted)]">
      <nav className="flex flex-wrap justify-center gap-x-4 gap-y-1">
        <Link to="/terms" className={link}>{t('common.footer.terms')}</Link>
        <Link to="/privacy" className={link}>{t('common.footer.privacy')}</Link>
        <Link to="/refund-policy" className={link}>{t('common.footer.refund')}</Link>
        <Link to="/contact" className={link}>{t('common.footer.contact')}</Link>
      </nav>
      <p className="mt-2">&copy; {new Date().getFullYear()} RedPanda Tech</p>
    </footer>
  );
};

export default PageFooter;
